export default __webpack_public_path__ + "125bcf6a1d4f25df0764aa71bece8c5f.svg";